jQuery(document).ready(function () {
    jQuery('a[href^=\\#].js-scroll-to').on('click', function(e) {
        e.preventDefault();
        var dest = jQuery(this).attr('href');
        jQuery('html,body').animate({ scrollTop: jQuery(dest).offset().top }, 'slow' );
    });
});
